import React, { Component } from "react";
import * as Icon from "react-feather";

import { ToolsReviewTools } from "../clients/Tools/kit/ToolsReviewItem";

class AgentReviewItemTools extends Component {
	render() {
		const { isEvidenceOpen, onToggleEvidence, hasLastMonth, isLastMonthOpen, onToggleLastMonth, isShowMeOpen, onShowMe } = this.props;
		const evidenceTool = { key: "evidence", title: "Evidence", icon: <Icon.FileText size={12} />, isActive: isEvidenceOpen, onClick: onToggleEvidence };
		const lastMonthTool = { key: "last_month", title: "Last month's decision", icon: <Icon.RotateCcw size={12} />, isActive: isLastMonthOpen, onClick: onToggleLastMonth };
		const showMeTool = { key: "show_me", title: "Show me in the books", icon: <Icon.Search size={12} />, isActive: !!isShowMeOpen, onClick: onShowMe };
		const historyTools = hasLastMonth ? [evidenceTool, lastMonthTool] : [evidenceTool];
		const tools = onShowMe ? [...historyTools, showMeTool] : historyTools;
		return <ToolsReviewTools tools={tools} />;
	}
}

export default AgentReviewItemTools;
